import { useLang } from '@/i18n';
import EfProductNaver, { EfProductNaverItemProps } from '@elem/ui/ef-product-naver';
import { useProductDispatch } from '../../ProductProvider';
import { useRouter } from 'next/router';
import { getProductFromGeneralKey } from '@/utils/productGetServerSideProps';
import { useGlobal } from '@/utils/useGlobal';
import { useProductStore } from '@elem/compPage/Rapid/ProductProvider';

export default function NavProduct() {
    const { gloproductlist } = useGlobal();
    const { t } = useLang('rapid.NavProduct');
    const { locale } = useRouter();
    const dispatch = useProductDispatch();
    const { pageStatus } = useProductStore();

    let tabs: EfProductNaverItemProps[] = [
        {
            key: 'Product',
            text: t('Product'),
        },
        {
            key: 'Support',
            text: t('Support'),
        },
        {
            key: 'Specs',
            text: t('Specs'),
        },
    ];
    const productMsg = getProductFromGeneralKey({ gloproductlist, generalKey: 'product_rapid' });

    const buyItem: EfProductNaverItemProps = {
        key: locale === 'jp' ? 'Bundles' : 'Buy',
        text: t('Buy') || 'Buy Now',
        url: productMsg?.buyLink,
    };

    const itemCallback = (item: any) => {
        dispatch({
            type: 'changeProductTabActive',
            payload: item.key,
        });
        // 切换时划回顶部
        setTimeout(() => {
            const headerElem = document.querySelector('.ecoflow-frame-header');
            window.scrollTo({
                top: headerElem?.clientHeight,
                behavior: 'smooth', // 可选，平滑滚动
            });
        }, 100);
    };

    const callbackBuy = () => {
        itemCallback(buyItem);
    };

    return (
        <EfProductNaver
            title={t('name')}
            tabs={tabs}
            buyItem={pageStatus !== 'statusA' ? buyItem : undefined}
            callbackTab={itemCallback}
            callbackBuy={callbackBuy}
        />
    );
}
